"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Google = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Google = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/_react.default.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#4285F4",
  d: "M22.68 12.013c0-.723-.058-1.447-.174-2.155h-9.882v4.089h5.661a4.927 4.927 0 0 1-2.095 3.233v2.657h3.376c1.98-1.845 3.114-4.576 3.114-7.824Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#34A853",
  d: "M12.624 22.406c2.823 0 5.21-.945 6.942-2.569L16.19 17.18c-.946.65-2.154 1.018-3.566 1.018-2.736 0-5.05-1.874-5.88-4.384H3.266v2.746c1.776 3.587 5.4 5.846 9.358 5.846Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#FBBC04",
  d: "M6.744 13.814a6.501 6.501 0 0 1 0-4.075V7.01H3.266a10.674 10.674 0 0 0 0 9.536l3.478-2.731Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#EA4335",
  d: "M12.624 5.355a5.596 5.596 0 0 1 4.017 1.594l2.998-3.04a10.036 10.036 0 0 0-7.015-2.761c-3.959 0-7.582 2.273-9.358 5.86l3.478 2.746c.83-2.524 3.144-4.399 5.88-4.399Z"
}))));
exports.Google = Google;
Google.displayName = "Google";